/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { TrackResizeContainer } from '../PRIVATE_TrackResizeContainer';
import { MeterBarWithDimensions } from './MeterBarWithDimensions';
import { MeterBarProps } from './meterBar.types';

/**
 * A Meter bar displays information graphically in a rectangular bar, highlighting a specific metric value's progress in relation to its min, max, or thresholds.
 */
export function MeterBar({ orientation, length, size, ...props }: MeterBarProps) {
  return (
    <>
      {size === 'fit' ? (
        <TrackResizeContainer width="100%" height="100%">
          {(width, height) => (
            <MeterBarWithDimensions
              width={width}
              height={height}
              orientation={orientation}
              size={size}
              {...props}
            />
          )}
        </TrackResizeContainer>
      ) : (
        <MeterBarWithDimensions size={size} length={length} orientation={orientation} {...props} />
      )}
    </>
  );
}
